/** Stable viewport height — prefers visualViewport to track mobile browser chrome. */
export function getViewportHeight(): number {
  if (typeof window === 'undefined') return 0
  return Math.round(window.visualViewport?.height ?? window.innerHeight)
}

export function subscribeViewportHeight(onChange: () => void): () => void {
  const handler = () => onChange()
  window.addEventListener('resize', handler)
  window.visualViewport?.addEventListener('resize', handler)
  window.visualViewport?.addEventListener('scroll', handler)
  return () => {
    window.removeEventListener('resize', handler)
    window.visualViewport?.removeEventListener('resize', handler)
    window.visualViewport?.removeEventListener('scroll', handler)
  }
}
